"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventName = void 0;
var EventName;
(function (EventName) {
    EventName["AppLaunch"] = "appLaunch";
    EventName["AppLogin"] = "appLogin";
    EventName["AppLogout"] = "appLogout";
    EventName["AppRegistration"] = "appRegistration";
    EventName["ConsumerEventScreen"] = "consumerEventScreen";
    EventName["ConsumerRatingScreen"] = "consumerRatingScreen";
    EventName["EmployeeStatus"] = "employeeStatus";
    EventName["InsuranceSubmitCOI"] = "insuranceSubmitCOI";
    EventName["InsuranceSubmitCoterieTOS"] = "insuranceSubmitCoterieTOS";
    EventName["JobAction"] = "jobAction";
    EventName["JobAutoPaused"] = "jobAutoPaused";
    EventName["JobAutoPauseFail"] = "jobAutoPauseFail";
    EventName["JobCompleted"] = "jobCompleted";
    EventName["JobDetails"] = "jobDetails";
    EventName["JobEnroute"] = "jobEnroute";
    EventName["JobFinalizeAccepted"] = "jobFinalizeAccepted";
    EventName["JobFinalizeRejected"] = "jobFinalizeRejected";
    EventName["JobFinalizeRequested"] = "jobFinalizeRequested";
    EventName["JobOnsite"] = "jobOnsite";
    EventName["JobPaused"] = "jobPaused";
    EventName["JobDeclined"] = "jobDeclined";
    EventName["JobHistory"] = "jobHistory";
    EventName["JobMaterialSubmitted"] = "jobMaterialSubmitted";
    EventName["JobProviderDeclined"] = "jobProviderDeclined";
    EventName["JobReceiptApprovedConsumer"] = "jobReceiptApprovedConsumer";
    EventName["JobResumeAccepted"] = "jobResumeAccepted";
    EventName["JobResumeRejected"] = "jobResumeRejected";
    EventName["JobResumeRequested"] = "jobResumeRequested";
    EventName["JobSuspendAccepted"] = "jobSuspendAccepted";
    EventName["JobSuspendRejected"] = "jobSuspendRejected";
    EventName["JobSuspendRequested"] = "jobSuspendRequested";
    EventName["JobTerminateAccepted"] = "jobTerminateAccepted";
    EventName["JobTerminateRejected"] = "jobTerminateRejected";
    EventName["JobTerminateRequested"] = "jobTerminateRequested";
    EventName["JobTimerAccepted"] = "jobTimerAccepted";
    EventName["JobTimerRejected"] = "jobTimerRejected";
    EventName["JobTimerRequested"] = "jobTimerRequested";
    EventName["JobTotalEarnedNoTip"] = "jobTotalEarnedNoTip";
    EventName["JobUnsuspendAccepted"] = "jobUnsuspendAccepted";
    EventName["JobUnsuspendCancelled"] = "jobUnsuspendCancelled";
    EventName["JobUnsuspendRequested"] = "jobUnsuspendRequested";
    EventName["JobUnsuspendRejected"] = "jobUnsuspendRejected";
    EventName["LeadRiskAction"] = "leadRiskAction";
    EventName["OnAddressCopied"] = "onAddressCopied";
    EventName["OnBoardingSkip"] = "onBoardingSkip";
    EventName["OnBoardingStartTour"] = "onBoardingStartTour";
    EventName["OnEstimateSent"] = "onEstimateSent";
    EventName["OnScreenLanded"] = "onScreenLanded";
    EventName["ProviderOffline"] = "providerOffline";
    EventName["ProviderOnline"] = "providerOnline";
    EventName["PaymentUpdated"] = "paymentUpdated";
    EventName["ProfileUpdated"] = "profileUpdated";
    EventName["PropertyDetails"] = "propertyDetails";
    EventName["ProviderAppRating"] = "providerAppRating";
    EventName["ReferralCodeDeleted"] = "referralCodeDeleted";
    EventName["ReferralCodeReplaced"] = "referralCodeReplaced";
    EventName["ReferrerCodeAdded"] = "referrerCodeAdded";
    EventName["ReferrerCodeDeleted"] = "referrerCodeDeleted";
    EventName["ReferrerCodeUpdated"] = "referrerCodeUpdated";
    EventName["RegistrationExit"] = "registrationExit";
    EventName["RegisterAgreeToTermsOfUse"] = "registerAgreeToTermsOfUse";
    EventName["RegisterSubmitId"] = "registerSubmitId";
    EventName["RegisterSubmitSelfie"] = "registerSubmitSelfie";
    EventName["RegisterAgreeToBackgroundCheck"] = "registerAgreeToBackgroundCheck";
    EventName["RegisterSubmitServices"] = "registerSubmitServices";
    EventName["RegisterAddBadge"] = "registerAddBadge";
    EventName["RegisterSkipInsurance"] = "registerSkipInsurance";
    EventName["RequestAccepted"] = "requestAccepted";
    EventName["RequestAcceptedOther"] = "requestAcceptedOther";
    EventName["RequestCancelled"] = "requestCancelled";
    EventName["RequestCreated"] = "requestCreated";
    EventName["RequestPMApprovalDenied"] = "requestPMApprovalDenied";
    EventName["RequestPMApprovalGranted"] = "requestPMApprovalGranted";
    EventName["RequestPMApprovalNeeded"] = "requestPMApprovalNeeded";
    EventName["RequestRejected"] = "requestRejected";
    EventName["RequestTimeout"] = "requestTimeout";
    EventName["ProviderEventScreen"] = "providerEventScreen";
    EventName["ReferralCodeAdded"] = "referralCodeAdded";
    EventName["ServiceSelected"] = "serviceSelected";
    EventName["UserLanguage"] = "userLanguage";
    EventName["UserMarketing"] = "userMarketing";
})(EventName = exports.EventName || (exports.EventName = {}));
